<template>
  <window :window-id="windowId">
    <window-tab :title="windowTitle">
      <switch-buttons :template-id="templateId"></switch-buttons>
      <div class="form-group form-row">
        <label :for="safeId('pollId')" class="col-sm-4 col-form-label">Poll ID</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('pollId')" v-model.lazy="pollId">
        </div>
      </div>
      <div class="form-group form-row">
        <label :for="safeId('title')" class="col-sm-4 col-form-label">Title</label>
        <div class="col-sm-8">
          <input type="text" class="form-control" :id="safeId('title')" v-model.lazy="title">
        </div>
      </div>
    </window-tab>
    <window-tab title="Settings" icon="cog">
      <template-settings :template-id="templateId"></template-settings>
    </window-tab>
  </window>
</template>

<script>
import { templateMixin } from '@/mixins'
import { mapOverlayData } from '../../utils'

export default {
  name: 'polling-results-list',
  mixins: [templateMixin],
  computed: {
    ...mapOverlayData(['pollId', 'title'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/templates/polling-results-list.vue